import $ from 'jquery';
import HCPConfirm from './classes/HCPConfirm';

// HCP 'confirm' mode
$(() => {
  HCPConfirm.init();
});



// WEBPACK FOOTER //
// ./scripts/hcp-confirm.js